import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-d4b32752")
const _hoisted_1 = { class: "view-contact" }
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_card_user = _resolveComponent("card-user")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_card_user, {
      user: _ctx.users[0]
    }, null, 8, ["user"]),
    _createVNode(_component_card_user, {
      user: _ctx.users[1]
    }, null, 8, ["user"])
  ]))
}